import classnames from 'classnames';
import * as React from 'react';
import './styles/ModalBoxBody.scss';

type ModalBoxBodyProps = React.PropsWithChildren<{
    disableScroll?: boolean;
    className?: string;
}>;

function ModalBoxBody({ children, disableScroll, className }: ModalBoxBodyProps) {
    const classes = classnames('palette-modal-box-body',
        { 'palette-modal-box-body--disable-scroll': disableScroll },
        className);

    return (
        <section
            className={classes}
            id="modal-description"
        >
            {children}
        </section>
    );
}

export default ModalBoxBody;
